import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import CustomInput from "../common/CustomInput";
import CustomButton from "../common/CustomButton";
import { useSelector } from "react-redux";
import { callApi } from "../common/Apicall";

const API_URL = process.env.REACT_APP_URL;

const TemporaryPasswordChange = ({ onClose, currentUserData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const currentUserId = useSelector(
    (state) => state?.data?.userInfo?.data?.data?.UserId
  );
  const { data } = useSelector((state) => state.data.userInfo.data);

  const initialModel = {
    password: "",
    confirmPassword: "",
    email: data.Email, // Include email for backend reference
  };

  const [passwordModel, setPasswordModel] = useState(initialModel);

  const handleSave = () => {
    if (!passwordModel.password || !passwordModel.confirmPassword) {
      toast.error("Please fill in both password fields!");
      return;
    }

    if (passwordModel.password !== passwordModel.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    if (passwordModel.password.length < 6) {
      toast.error("Password must be at least 6 characters long!");
      return;
    }

    setIsLoading(true);
    const payload = {
      ...currentUserData,
      password: passwordModel?.password,
    };

    delete payload.profilePicture;
    !payload.updatedAt && delete payload.updatedAt;

    callApi(API_URL + "/Users/SaveUser", "POST", payload, true)
      .then((res) => {
        onClose();
        toast.success("Password changed successfully! Please login again.");
        // You might want to add a logout action here
      })
      .catch((err) => {
        toast.error(err.message || "Error occurred while changing password!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="p-6 max-w-md mx-auto">
      {isLoading ? (
        <div className="flex justify-center items-center min-h-[25vh]">
          <div className="animate-spin border-4 border-blue-500 border-t-transparent w-8 h-8 rounded-full"></div>
        </div>
      ) : (
        <>
          <div className="mb-6 text-center">
            <h2 className="text-xl font-bold text-gray-800 mb-2">
              Temporary Password Detected
            </h2>
            <p className="text-gray-600">
              For security reasons, please change your temporary password to a
              permanent one before proceeding.
            </p>
          </div>

          <div className="space-y-4">
            <CustomInput
              name="password"
              label="New Password"
              value={passwordModel.password}
              type="password"
              onChange={(e) =>
                setPasswordModel({
                  ...passwordModel,
                  [e.target.name]: e.target.value,
                })
              }
              required
              placeholder="Enter at least 6 characters"
            />

            <CustomInput
              name="confirmPassword"
              label="Confirm New Password"
              value={passwordModel.confirmPassword}
              type="password"
              onChange={(e) =>
                setPasswordModel({
                  ...passwordModel,
                  [e.target.name]: e.target.value,
                })
              }
              required
              placeholder="Re-enter your new password"
            />
          </div>

          <div className="mt-8 flex justify-end space-x-4">
            {/* <CustomButton
              label="Cancel"
              onClick={onClose}
              buttonType="cancel"
            /> */}
            <CustomButton
              label="Change Password"
              onClick={handleSave}
              disabled={isLoading}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default TemporaryPasswordChange;
